module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-paper"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "summary-wrapper"
  }, [_c('a', {
    staticClass: "bill-filter-cancel"
  }), _vm._v(" "), _c('navbar', {
    attrs: {
      "title": "选择证照类型"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-filter-shell"
  }, [_c('ul', {
    staticClass: "summary-filter-ul paper-select-ul"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('01', '营业执照')
      }
    }
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('02', '税务登记证')
      }
    }
  }, [_vm._v("税务登记证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('03', '组织机构代码证')
      }
    }
  }, [_vm._v("组织机构代码证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('04', '卫生许可证')
      }
    }
  }, [_vm._v("卫生许可证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('05', '生产许可证')
      }
    }
  }, [_vm._v("生产许可证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('06', '食品经营许可证')
      }
    }
  }, [_vm._v("食品经营许可证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('07', '检验报告')
      }
    }
  }, [_vm._v("检验报告")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('08', 'ISO认证证书')
      }
    }
  }, [_vm._v("ISO认证证书")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('09', '商标注册证')
      }
    }
  }, [_vm._v("商标注册证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('10', '健康证')
      }
    }
  }, [_vm._v("健康证")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.selectPaper('11', '其他')
      }
    }
  }, [_vm._v("其他")])])])], 1)]), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21a8a1e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectPaper.vue
// module id = 546
// module chunks = 1